import {
  convertToDayJs,
  getCurrentTime,
} from 'shared/src/utils/date-utils';
import { isNotNil } from 'shared/src/utils/isNotNil';

/** promotion_countdown 하단 배너 노출 상한 (3일) */
const PROMOTION_COUNTDOWN_MAX_MS = 3 * 24 * 60 * 60 * 1000;

export type BottomDockedTimeSaleBanner = {
  title: string;
  finishedAt: string;
};

type PromotionCountdownLike = {
  banner_title?: string | null;
  finished_at?: string | null;
} | null;

type TimeSaleBannerLike = {
  title: string;
  finished_at: string;
} | null;

/**
 * 하단 도킹 타임세일 배너 해석.
 * - promotion_countdown.banner_title 우선, 잔여 < 72h일 때만 후보
 * - 후보가 만료(잔여 ≤ 0)면 time_sale_banner로 폴백하지 않고 null → 넛지 복귀
 * - 72h 이상 남으면 time_sale_banner로 폴백 (미래인 경우만 노출)
 */
export const resolveBottomDockedTimeSaleBanner = ({
  promotionCountdown,
  timeSaleBanner,
}: {
  promotionCountdown: PromotionCountdownLike;
  timeSaleBanner: TimeSaleBannerLike;
}): BottomDockedTimeSaleBanner | null => {
  const now = getCurrentTime();
  const promoTitle = promotionCountdown?.banner_title;
  const promoFinishedAt = promotionCountdown?.finished_at;

  if (isNotNil(promoTitle) && isNotNil(promoFinishedAt)) {
    const finishedMs = convertToDayJs(promoFinishedAt).valueOf();
    if (
      Number.isFinite(finishedMs) &&
      finishedMs - now < PROMOTION_COUNTDOWN_MAX_MS
    ) {
      // 72h 미만 후보로 선택됨. 만료면 time_sale로 폴백하지 않음.
      if (finishedMs > now) {
        return {
          title: promoTitle,
          finishedAt: promoFinishedAt,
        };
      }
      return null;
    }
  }

  if (isNotNil(timeSaleBanner)) {
    const finishedMs = convertToDayJs(timeSaleBanner.finished_at).valueOf();
    if (Number.isFinite(finishedMs) && finishedMs > now) {
      return {
        title: timeSaleBanner.title,
        finishedAt: timeSaleBanner.finished_at,
      };
    }
  }

  return null;
};
